import { alpha, Chip, styled } from '@mui/material';

export const HintChip = styled(Chip)(({ theme }) => ({
  borderRadius: '7px',
  fontWeight: 600,
  fontSize: '0.72rem',
  color: theme.palette.info.main,
  backgroundColor: alpha(theme.palette.primary.main, 0.12),
  border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
}));

export const LatestChip = styled(Chip)(({ theme }) => ({
  borderRadius: '7px',
  fontWeight: 700,
  fontSize: '0.68rem',
  letterSpacing: '0.03em',
  color: theme.palette.accent.main,
  backgroundColor: alpha(theme.palette.accent.main, 0.16),
  border: `1px solid ${alpha(theme.palette.accent.main, 0.4)}`,
}));
